/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Invoices_CountInputs */

const en_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} invoice`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} invoices`);
	return /** @type {LocalizedString} */ ("admin.dashboard.invoices_count");
};

const de_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("de", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} Rechnungen`)
};

const es_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("es", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} facturas`)
};

const fr_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("fr", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} factures`)
};

const nl_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} factuur`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} facturen`);
	return /** @type {LocalizedString} */ ("admin.dashboard.invoices_count");
};

const it_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("it", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} fatture`)
};

const pt_br2_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pt-BR", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} faturas`)
};

const pl_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pl", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} faktur`)
};

const hu_admin_dashboard_invoices_count = /** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("hu", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} számla`)
};

/** @type {(inputs: Admin_Dashboard_Invoices_CountInputs) => LocalizedString} */
const ro_admin_dashboard_invoices_count = en_admin_dashboard_invoices_count;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} invoice" |
* | "other" | "{count} invoices" |
*
* @param {Admin_Dashboard_Invoices_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoices_count = /** @type {((inputs: Admin_Dashboard_Invoices_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoices_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoices_count(inputs)
	if (locale === "de") return de_admin_dashboard_invoices_count(inputs)
	if (locale === "es") return es_admin_dashboard_invoices_count(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoices_count(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoices_count(inputs)
	if (locale === "it") return it_admin_dashboard_invoices_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoices_count(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoices_count(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoices_count(inputs)
	return ro_admin_dashboard_invoices_count(inputs)
});
export { admin_dashboard_invoices_count as "admin.dashboard.invoices_count" }